import { isFeatureEnabled } from '@/config';
import { SELECT_OPINION_PHRASES } from '@/consts/phrases/selectOpinionPhrases';
import { useAccountStore } from '@/store/accountStore';
import { ExpertNetworkStatusEnum } from '@/types/types/forms/account/account.interface';
import { IAuthMenuItem } from './menuUtils';
import { Subpaths } from '@/types/enums/paths';
import SelectOpinionMenuIcon from '@/assets/theme/default/selectOpinionIcons/SelectOpinionMenuIcon';

export const useAuthMenuItemsByAccount = ({
    authMenuItems,
}: {
    authMenuItems: IAuthMenuItem[];
}) => {
    const expertNetworkStatus = useAccountStore((state) => state.expertNetworkStatus);

    const hasExpertNetworkButton =
        expertNetworkStatus != null &&
        (expertNetworkStatus === ExpertNetworkStatusEnum.INVITED ||
            expertNetworkStatus === ExpertNetworkStatusEnum.REGISTERED);

    const expertNetworkLink =
        expertNetworkStatus === ExpertNetworkStatusEnum.REGISTERED
            ? Subpaths.SelectOpinionConsultingOpportunities
            : Subpaths.SelectOpinion;

    const authMenuItemsByAccount = [...authMenuItems];

    if (hasExpertNetworkButton && isFeatureEnabled('selectOpinion')) {
        const surveysIndex = authMenuItemsByAccount.findIndex((item) => item.href === '/surveys');
        if (surveysIndex !== -1) {
            authMenuItemsByAccount.splice(surveysIndex + 1, 0, {
                phraseId: SELECT_OPINION_PHRASES.EXPERT_NETWORK,
                href: expertNetworkLink,
                data: null,
                icon: <SelectOpinionMenuIcon />,
                className: 'selectOpinionTopMenuItem',
            });
        }
    }

    return { authMenuItemsByAccount };
};
